import widgets from "./widgetsReducer";
import dashboardContainer from "./dashboardContainerReducer";
import filters from "./filtersReducer";
import settings from "./settingReducer";
import userInfo from "./userInfoReducer";
import widgetHash from "./widgetHashReducer";
import dashboards from "./dashboardReducer";
import currentDashboardId from "./currentDashboardReducer";
import currentWidgetId from "./currentWidgetReducer";
import userAppsInfo from "./UserAppsReducer";
import previewWidgets from "./previewWidgetsReducer";
import kpiDashboardContainer from "./kpiDashboardContainerReducer";
import kpiDashboards from "./kpiDashboardReducer";

export default {
	widgets,
	previewWidgets,
	dashboardContainer,
	filters,
	settings,
	userInfo,
	widgetHash,
	dashboards,
	currentDashboardId,
	currentWidgetId,
	userAppsInfo,
	kpiDashboardContainer,kpiDashboards
};
